import { render, staticRenderFns } from "./UserRolesTable.vue?vue&type=template&id=6f2b3fe0"
import script from "./UserRolesTable.vue?vue&type=script&lang=js"
export * from "./UserRolesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports